module.exports = __webpack_public_path__ + "static/media/symtome_icon.fe6e443b.svg";